import axios from 'src/api/client/axios'
import { adaptApiGetServerUserResponse } from './getserveruser.service.adapter'
import {
  ApiGetServerUserResponse,
  GetServerUserParams
} from './getserveruser.service.types'

export const apiGetServerUser = async (data: GetServerUserParams) => {
  const response = await axios.post<ApiGetServerUserResponse>(
    'https://api.availroom.com/sialdPMS_Channel/service/resourcescrossorigin/webcrossorigin/getserveruser',
    data,
    {
      headers: {
        Authorization: 'Bearer FED701B733B64E2BB73F4C97BA6AA363'
      }
    }
  )
  return adaptApiGetServerUserResponse(response.data)
}
